// Full-document render of the password-reset complete view: the sealy
// AccountShell wrapping the confirmation copy + log-in button (the plain
// `button` class — sealy has no styling for the shared body's lochmara-blue
// variant). All copy arrives pre-localized as props (server-side gettext) so
// fr_CA is preserved.
import React from "react";

import { templates } from "@reactivated";

import { AccountShell } from "../components/AccountShell";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetCompleteDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountShell
            hasNav={props.has_nav}
            sideNav={props.side_nav}
            title={props.content_title}
        >
            {props.complete_text}
            <p>{props.body_text}</p>
            <p>
                <a href={props.login_url} className="button">
                    {props.login_label}
                </a>
            </p>
        </AccountShell>
    </PageSkeleton>
);
